import React from 'react'
import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

interface Props {
  forms: { title: string; lexUrl: string }[] | null
}

export const FormRequirementForms = ({ forms }: Props) => {
  const classes = useStyles()

  return (
    <TableContainer className={classes.formTable}>
      <Table
        style={{
          width: '100%',
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell size="small">Tytuł</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {forms?.map((form, index) => {
            const { title, lexUrl } = form

            return (
              <TableRow key={`form[${index}]`}>
                <TableCell size="medium" className={classes.formNoWrapCell}>
                  {lexUrl ? (
                    <Link href={lexUrl} target="_blank" rel="noopener">
                      {title}
                    </Link>
                  ) : (
                    title
                  )}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export const useStyles = makeStyles((theme) => {
  return {
    formTable: {
      marginBottom: theme.spacing(2),
      '& td, th': {
        paddingLeft: '0',
        fontSize: '1rem',
      },
    },
    formNoWrapCell: {
      width: 280,
    },
  }
})
